export const REDIRECT_URI = `${window.location.origin}/trips/calendar`;
